import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { Translate } from '@change-corgi/core-react/i18n';
import type { TrackingProperties } from '@change-corgi/tracking-properties';

import { ScrollTrackingWaypoint } from '../../../../../ScrollTrackingWaypoint';
import { AddMediaHit } from '../../../AddMediaHit';
import { MediaHitsScrollButtons } from '../MediaHitsScrollButtons';

type MediaHitsHeaderProps = {
	showAdd: boolean;
	trackingData?: TrackingProperties;
	onScrollLeft: () => void;
	onScrollRight: () => void;
	canScrollLeft: boolean;
	canScrollRight: boolean;
	showScrollButtons: boolean;
};

export const MediaHitsHeader: React.FC<MediaHitsHeaderProps> = ({
	showAdd,
	trackingData,
	onScrollLeft,
	onScrollRight,
	canScrollLeft,
	canScrollRight,
	showScrollButtons,
}) => {
	return (
		<div className="pt-10" data-testid="media-hits-header-container">
			<div className="flex items-center">
				<Text as="h2" variant="heading" size="large">
					<Translate value="corgi.signed_petition_home.media_mentions_modal.heading" />
				</Text>
				{showScrollButtons && (
					// Buttons inside already have data-qa attributes
					// eslint-disable-next-line @change-corgi/require-data-qa-attribute
					<MediaHitsScrollButtons
						onScrollLeft={onScrollLeft}
						onScrollRight={onScrollRight}
						canScrollLeft={canScrollLeft}
						canScrollRight={canScrollRight}
					/>
				)}
			</div>
			<ScrollTrackingWaypoint name="campaign_media_hits_view" trackingData={trackingData} />
			{showAdd && <AddMediaHit />}
		</div>
	);
};
